module.exports = __webpack_public_path__ + "static/img/dy1-4.8548533.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy1-4.png
// module id = 942
// module chunks = 0